export default function getQueryParamValue(p: string) {
  const str = new URLSearchParams(window.location.search);

  return str.get(p) || '';
}
